import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Button, Col, Label } from "reactstrap";
import { addToArray, deleteDocument, saveData } from "../../firebase/utility";
import ConfirmationModal from "../modals/ConfirmationModal";
import LabelModal from "../modals/LabelModal";
import TrackingOthersItem from "./OthersTracking";
import { TrackingFedexItem } from "./TrackingFedexItem";
import { TrackingUpsItem } from "./TrackingUpsItem";
import { TrackingUspsItem } from "./TrackingUspsItem";
import { Radio } from "antd";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import { refreshTracking } from "../../api/TrackingApi";
import { useSelector } from "react-redux";
const OutBoundTracking = ({
  labels,
  product,
  setProduct,
  orderData,
  itemIndex,
  setSelectedTracking,
  toggleEditTracking,
  refreshSaleOrderDetails,
}) => {
  const { user } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);
  const [labelModal, setLabelModal] = useState(false);
  const toggleLabelModal = () => setLabelModal(!labelModal);
  const [image, setImage] = useState(null);
  const [mode, setMode] = useState("Direct Ship");
  const [modalOpen, setModalOpen] = useState(false);
  const [trackingIdToDelete, setTrackingIdToDelete] = useState(null);
  const toggleModal = () => setModalOpen(!modalOpen);
  const [labelData, setLabelData] = useState([]);
  const [comingTotm, setComingTotm] = useState(0);
  const [directShip, setDirectShip] = useState(0);
  const [showCount, setShowCount] = useState(1);
  const handleDeleteTracking = (id) => {
    setTrackingIdToDelete(id);
    toggleModal();
  };
  const handleModeChange = (e) => {
    setMode(e.target.value);
  };
  const handleDelete = () => {
    if (!trackingIdToDelete) return;
    deleteDocument("Trackings", trackingIdToDelete).then(() => {
      toast.success("Tracking Deleted Successfully !");
      let result = addToArray("Orders", orderData?._id, "logs", {
        createdAt: Date.parse(new Date()),
        createdBy: user,
        message: `Tracking has been Deleted by ${user?.username}`,
      });
      if (result) {
        setTrackingIdToDelete(null);
        refreshSaleOrderDetails();
        toggleModal();
      }
    });
  };
  const refreshTrackingData = (id) => {
    setLoading(true);
    refreshTracking(id, (res) => {
      if (res?.status === 200) {
        setLoading(false);
        toast(res?.data);
      }
    });
  };
  useEffect(() => {
    if (!labels || labels.length === 0) return;
    const hasDirectShip = labels.some(
      (label) =>
        label?.labelData?.trackingType === "Direct Ship" ||
        label?.labelData?.trackingType === ""
    );
    const hasComingTM = labels.some(
      (label) => label?.labelData?.trackingType === "Coming To Techmicro"
    );
    const hasOthers = labels.some(
      (label) => label?.labelData?.trackingType === "others"
    );
    if (hasDirectShip) {
      setMode("Direct Ship");
    } else if (hasComingTM) {
      setMode("Coming To Techmicro");
    } else if (hasOthers) {
      setMode("others");
    } else {
      setMode("Direct Ship"); // fallback
    }
  }, [labels]);
  useEffect(() => {
    const filterLabels = labels?.filter((label) => {
      const trackingType = label?.labelData?.trackingType ?? "";
      if (
        (mode === "Direct Ship" &&
          (trackingType === "Direct Ship" || trackingType === "")) ||
        (mode === "Coming To Techmicro" &&
          trackingType === "Coming To Techmicro") ||
        (mode === "others" && trackingType === "others")
      ) {
        return true;
      }
      return false;
    });
    setLabelData(filterLabels);
    setDirectShip(
      labels.filter(
        (label) =>
          label?.labelData?.trackingType === "Direct Ship" ||
          label?.labelData?.trackingType === ""
      ).length
    );
    setComingTotm(
      labels.filter(
        (label) => label?.labelData?.trackingType === "Coming To Techmicro"
      ).length
    );
  }, [labels, mode]);
  const handleShowMore = () => {
    setShowCount(labels?.length);
  };
  const handleShowLess = () => {
    setShowCount(1);
  };
  const getContainerStyle = () => {
    if (mode === "Direct Ship") {
      return { backgroundColor: "#f4fdf8", border: "1px solid #bbf7d0", labelColor: "text-success", radioClass: "radio-group-success" };
    } else if (mode === "Coming To Techmicro") {
      return { backgroundColor: "#eff6ff", border: "1px solid #bfdbfe", labelColor: "text-primary", radioClass: "radio-group-primary" };
    } else {
      return { backgroundColor: "#fcfcfc", border: "1px solid #e2e8f0", labelColor: "text-secondary", radioClass: "radio-group-secondary" };
    }
  };

  const themeStyle = getContainerStyle();

  return (
    <>
      <ConfirmationModal
        isOpen={modalOpen}
        toggle={toggleModal}
        onConfirm={handleDelete}
      />
      <div className="p-2 mx-3 mb-2 rounded-3" style={{ backgroundColor: themeStyle.backgroundColor, border: themeStyle.border }}>      <Col md={12} className="d-flex justify-content-between m-auto px-1">
        <Label className={`fw-bold ${themeStyle.labelColor} mb-0`} style={{ fontSize: "1.1rem" }}>Trackings</Label>
        <div className="d-flex align-items-center gap-2">
          <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
            <div
              onClick={() => handleModeChange({ target: { value: "Direct Ship" } })}
              style={{
                cursor: "pointer",
                padding: "6px 12px",
                fontSize: "13px",
                borderRadius: "6px",
                fontWeight: mode === "Direct Ship" ? "bold" : "500",
                color: mode === "Direct Ship" ? "#166534" : "#64748b",
                backgroundColor: mode === "Direct Ship" ? "#dcfce7" : "#f8fafc",
                border: mode === "Direct Ship" ? "1px solid #86efac" : "1px solid #e2e8f0",
                transition: "all 0.2s"
              }}
            >
              Direct Ship ({directShip})
            </div>
            <div
              onClick={() => handleModeChange({ target: { value: "Coming To Techmicro" } })}
              style={{
                cursor: "pointer",
                padding: "6px 12px",
                fontSize: "13px",
                borderRadius: "6px",
                fontWeight: mode === "Coming To Techmicro" ? "bold" : "500",
                color: mode === "Coming To Techmicro" ? "#1d4ed8" : "#64748b",
                backgroundColor: mode === "Coming To Techmicro" ? "#dbeafe" : "#f8fafc",
                border: mode === "Coming To Techmicro" ? "1px solid #bfdbfe" : "1px solid #e2e8f0",
                transition: "all 0.2s"
              }}
            >
              Coming To US ({comingTotm})
            </div>
          </div>
          {labelData?.length > 1 && (
            <div>
              {showCount < labelData.length ? (
                <Button
                  size="sm"
                  color="success"
                  className=" mb-2 text-white"
                  onClick={handleShowMore}
                >
                  Show <FaChevronDown />
                </Button>
              ) : (
                <Button
                  size="sm"
                  color="danger"
                  className=" mb-2 text-white"
                  onClick={handleShowLess}
                >
                  Hide <FaChevronUp />
                </Button>
              )}
            </div>
          )}
        </div>
      </Col>
        <Col md={12} className="m-auto px-1 mt-0">
          <div className="d-flex flex-column align-items-center w-100">
            {labelData?.length > 0 ? (
              labelData
                .slice(0, showCount)
                ?.sort((a, b) => new Date(b?.createdAt) - new Date(a?.createdAt))
                .map((item, index) =>
                  item?.labelData?.type === "fedex" ? (
                    <TrackingFedexItem
                      key={index}
                      index={index}
                      date={item?.createdAt}
                      trackingData={item?.labelData?.trackingData}
                      type={item?.labelData?.type}
                      labelImage={item?.labelData?.labelImage}
                      toggleModal={toggleModal}
                      toggleLabelModal={toggleLabelModal}
                      setImage={setImage}
                      deleteTracking={handleDeleteTracking}
                      setSelectedTracking={setSelectedTracking}
                      toggleEditTracking={toggleEditTracking}
                      quantity={item?.labelData?.quantity}
                      trackingType={
                        item?.labelData?.trackingType ?? "Direct Ship"
                      }
                      trackingNumber={item?.labelData?.trackingNumber || ""}
                      id={item?._id}
                      line_items={item?.lineItemDetails}
                      orderLineItems={orderData?.line_items}
                      itemIndex={itemIndex}
                      product={product}
                      shippingCost={item?.shippingCost}
                      loading={loading}
                      refreshTrackingData={refreshTrackingData}
                    />
                  ) : item?.labelData?.type === "ups" ? (
                    <TrackingUpsItem
                      key={index}
                      index={index}
                      date={item?.createdAt}
                      trackingData={item?.labelData?.trackingData}
                      type={item?.labelData?.type}
                      labelImage={item?.labelData?.labelImage}
                      toggleLabelModal={toggleLabelModal}
                      setImage={setImage}
                      toggleModal={toggleModal}
                      deleteTracking={handleDeleteTracking}
                      setSelectedTracking={setSelectedTracking}
                      toggleEditTracking={toggleEditTracking}
                      quantity={item?.labelData?.quantity}
                      trackingType={
                        item?.labelData?.trackingType ?? "Direct Ship"
                      }
                      trackingNumber={item?.labelData?.trackingNumber || ""}
                      id={item?._id}
                      line_items={item?.lineItemDetails}
                      orderLineItems={orderData?.line_items}
                      itemIndex={itemIndex}
                      product={product}
                      shippingCost={item?.shippingCost}
                      loading={loading}
                      refreshTrackingData={refreshTrackingData}
                    />
                  ) : item?.labelData?.type === "usps" ? (
                    <TrackingUspsItem
                      key={index}
                      index={index}
                      date={item?.createdAt}
                      trackingData={item?.labelData?.trackingData}
                      service={item?.labelData?.trackingData[0]?.serviceCode}
                      type={item?.labelData?.type}
                      labelImage={item?.labelData?.labelImage}
                      toggleLabelModal={toggleLabelModal}
                      setImage={setImage}
                      toggleModal={toggleModal}
                      deleteTracking={handleDeleteTracking}
                      quantity={item?.labelData?.quantity}
                      setSelectedTracking={setSelectedTracking}
                      toggleEditTracking={toggleEditTracking}
                      trackingType={
                        item?.labelData?.trackingType ?? "Direct Ship"
                      }
                      trackingNumber={item?.labelData?.trackingNumber || ""}
                      price={item?.labelData?.price}
                      id={item?._id}
                      line_items={item?.lineItemDetails}
                      orderLineItems={orderData?.line_items}
                      itemIndex={itemIndex}
                      product={product}
                      shippingCost={item?.shippingCost}
                      refreshTrackingData={refreshTrackingData}
                      loading={loading}
                    />
                  ) : item?.labelData?.type === "others" ? (
                    <TrackingOthersItem
                      key={index}
                      data={item}
                      tracking={item?.labelData?.trackingData}
                      trackingNumber={item?.labelData?.trackingNumber}
                      service={item?.labelData?.company ?? item?.labelData?.type}
                      id={item?._id}
                      date={item?.createdAt}
                      quantity={item?.labelData?.quantity}
                      trackingType={
                        item?.labelData?.trackingType ?? "Direct Ship"
                      }
                      deleteTracking={handleDeleteTracking}
                      toggleEditTracking={toggleEditTracking}
                      setSelectedTracking={setSelectedTracking}
                      itemIndex={itemIndex}
                      line_items={item?.lineItemDetails}
                      orderLineItems={orderData?.line_items}
                      product={product}
                      shippingCost={item?.shippingCost}
                      refreshTrackingData={refreshTrackingData}
                    />
                  ) : null
                )
            ) : (
              <div className="text-center my-2 text-danger">
                Selected Mode tracking not found
              </div>
            )}
          </div>
        </Col>
      </div>
    </>
  );
};
export default OutBoundTracking;
